import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins, Emit } from "vue-property-decorator";
import simplebar from "simplebar-vue";
import BaseMixer from "@/router/views/BaseMixer";
import ECRadialBar from "@/components/widgets/ECRadialBar.vue";
import Switches from "vue-switches";
import { IPACycleEmployeeReviewDTO } from "@/store/models/cycle/paCycleEmployeeReviewDTO";
import { Guid } from "guid-typescript";
let CycleReview = /** @class */ (() => {
    var _a, _b;
    let CycleReview = class CycleReview extends Mixins(BaseMixer) {
        reviewSelected() {
            this.ReviewSelected(this.review.id, false);
        }
        ReviewSelected(reviewId, isMeetingSelected) { }
        reviewMeetingClicked() {
            this.ReviewSelected(this.review.id, true);
        }
        getReviewProgressPercentage(review) {
            return [review.percentComplete];
        }
        get hasRightsForViewReviewMeeting() {
            return this.rightsHelper(this.rightsConstant.Cycle.CanManageReviewMeeting());
        }
        get reviewStatusClass() {
            if (this.review.reviewStatus == "Delivered") {
                return "re-delivered";
            }
            if (this.review.reviewStatus == "Ready For Delivery") {
                return "ready-for-delivery";
            }
            else {
                return "re-progressing";
            }
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IPACycleEmployeeReviewDTO !== "undefined" && IPACycleEmployeeReviewDTO) === "function" ? _a : Object)
    ], CycleReview.prototype, "review", void 0);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof Guid !== "undefined" && Guid) === "function" ? _b : Object, Boolean]),
        __metadata("design:returntype", void 0)
    ], CycleReview.prototype, "ReviewSelected", null);
    CycleReview = __decorate([
        Component({
            name: "CycleReview",
            components: {
                simplebar,
                ECRadialBar,
                Switches,
            },
        })
    ], CycleReview);
    return CycleReview;
})();
export default CycleReview;
